module.exports = __webpack_public_path__ + "img/selected5-min.95a9c7d1.png";